<template>
  <div id="listing-filters-modal" class="pt-0 px-0">
    <b-container>
      <b-row class="modalHeader px-2">
        <b-col class="d-flex justify-content-between align-items-center">
          <div class="cancel" @click="$root.$emit('closeModal')">
            <img src="@/assets/icons/close.svg" />
          </div>
          <div>
            <span class="lead">All filters</span>
          </div>
          <div @click="clearFilters" class="underline font-size-xs">Clear</div>
        </b-col>
      </b-row>
      <b-row class="modalContent pt-4">
        <listing-filters isMobile :onFilterUpdate="onFilterUpdate" :homeType="homeType" />
      </b-row>
      <b-row class="modalActions px-4">
        <b-col md="4" offset-md="4" :class="{ 'px-5': !isMobile }">
          <b-btn variant="dark" @click="viewResultsOnClick" block>See results</b-btn>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ListingFilters from '@/components/Listings/ListingsFilters.vue'

export default {
  name: 'ListingFiltersModal',
  components: {
    ListingFilters,
  },
  props: {
    homeType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newFilterQuery: this.$route.query,
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    onFilterUpdate(newFilterQuery) {
      this.newFilterQuery = { ...this.newFilterQuery, ...newFilterQuery }
    },
    async viewResultsOnClick() {
      await this.$router.replace({ query: this.newFilterQuery }).catch(() => {})
      this.$root.$emit('closeModal')
    },
    async clearFilters() {
      const { homeType } = this.$route.query
      await this.$router
        .replace({
          query: homeType
            ? {
                homeType,
              }
            : {},
        })
        .catch(() => {})
      this.$root.$emit('closeModal')
    },
  },
}
</script>

<style lang="scss">
#listing-filters-modal {
  padding-bottom: 30px;
  background: white;
  .modalHeader {
    height: $mobile-navbar-height;
    img {
      height: 14px;
      width: 14px;
    }
  }
  .modalActions {
    opacity: 0;
    animation: fadeAndScrollUp 0.35s forwards 0.35s;
    position: sticky;
    bottom: 30px;
    z-index: 100;
  }
}
</style>
